(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_3e80131"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hs-announcement-bar')) {
  customElements.define('hs-announcement-bar', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const editor = Boolean(window.Shopify?.designMode);
      this.hidden = false;
      if (this.dataset.dismissible !== 'true') return;
      try {
        this.hidden = !editor && localStorage.getItem(this.dataset.storageKey) === '1';
      } catch {}
      const dismiss = () => {
        if (editor) return;
        this.hidden = true;
        try { localStorage.setItem(this.dataset.storageKey, '1'); } catch {}
      };
      this.querySelector('[data-close]')?.addEventListener('click', dismiss, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') dismiss();
      }, { signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
